import Tabela from './Tabela'
import enhance from './Tabela.enhancer'

export default enhance(Tabela)



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/PesquisaItensCustomForm/Tabela/index.js